import {Inject, Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {

  constructor(private router: Router, @Inject(DOCUMENT) private document: Document) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        // Status 503 = maintenance mode
        // Status 0 = network error or CORS-blocked response (often a 503 without CORS headers)
        if (err.status === 503 || err.status === 0) {
          if (!this.router.isActive('/maintenance', false)) {
            this.router.navigate(['/maintenance'], {
              queryParams: {
                redirectTo: this.document.location.href
              }
            });
          }
        }

        return throwError(err);
      })
    );
  }
}
